import { render, staticRenderFns } from "./OthersNews.vue?vue&type=template&id=b785084c"
import script from "./OthersNews.vue?vue&type=script&lang=js"
export * from "./OthersNews.vue?vue&type=script&lang=js"
import style0 from "./OthersNews.vue?vue&type=style&index=0&id=b785084c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports